// MultiCheckboxInput.js
import './Checkbox.css';

function MultiCheckboxInput({
                                label,
                                options = [],
                                value = [],
                                onChange,
                                contentRenderer
                            }) {
    const selected = Array.isArray(value) ? value : (value ? [value] : []);

    const handleToggle = (optValue) => (e) => {
        const checked = e.target.checked;
        let next = selected;

        if (checked) {
            if (!selected.includes(optValue)) next = [...selected, optValue];
        } else {
            next = selected.filter(v => v !== optValue);
        }

        onChange && onChange(next);
    };

    const renderContent = (option, checked) => {
        if (contentRenderer) {
            // předáme handler na konkrétní hodnotu
            return contentRenderer(option, checked, handleToggle(option.value));
        }
        return (
            <>
                {option.label}
                <input
                    type="checkbox"
                    name={option.value}
                    value={option.value}
                    checked={checked}
                    onChange={handleToggle(option.value)}
                />
            </>
        );
    };

    return (
        <div className="MultiCheckboxInput">
            {label}
            <div className="choices">
                {options.map(option => (
                    <div key={option.value}>
                        <label className="choice-label">
                            {renderContent(option, selected.includes(option.value))}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MultiCheckboxInput;
